// app/src/screens/Maintenance.jsx — the dark-launch / maintenance page (MAINT-MODE §8). The
// app's visual language (logo + wordmark), the admin's message VERBATIM, and nothing else — no
// nav, no sign-in. It polls /v1/status and reloads itself the moment maintenance lifts, so the
// app comes back on its own (the report's "flip OFF → app back within ~15s").
//
// KNOWN SIMPLIFICATION (flagged in the MAINT-MODE report): the single fallback line here is
// English-only; the 24-language pass is later. The admin's message renders exactly as typed.

import React, { useEffect } from 'react';
import { useI18n } from '../i18n/index.jsx';
import { useSession } from '../lib/session.jsx';

export default function Maintenance({ message }) {
  const { t } = useI18n();
  const { api } = useSession();

  useEffect(() => {
    let alive = true;
    const id = setInterval(async () => {
      const r = await api.get('status');
      if (alive && r.kind === 'ok' && r.maintenance === false) window.location.reload();
    }, 10000);
    return () => { alive = false; clearInterval(id); };
  }, [api]);

  const text = message && message.trim() ? message : 'We’re down for maintenance and will be back shortly.';

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--paper)', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 420, textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9, marginBottom: 20 }}>
          <img src="/logo-mark.png" alt="" style={{ width: 30, height: 30 }} />
          <span style={{ font: '700 22px var(--font-body)', letterSpacing: '-.02em' }}>{t('app.short')}</span>
        </div>
        <div className="q-card" style={{ padding: 26, boxShadow: 'var(--shadow-card)' }}>
          <p style={{ font: '600 17px var(--font-body)', margin: 0, lineHeight: 1.55, whiteSpace: 'pre-wrap' }}>{text}</p>
        </div>
      </div>
    </div>
  );
}
